<template>
	<div>
		<button
			:class="['c-page-header__button--round', className]"
			:aria-expanded="showMenu"
			aria-controls="mobile-menu"
			id="mobile-menu-button"
			@click="openMenu"
		>
			<v-icon name="icon-menu" size="s" />
			‍<span class="t-visually-hidden">{{ menuButtonText }}</span>
		</button>
		<nav
			id="mobile-menu"
			aria-label="Mobilmeny"
			:class="['c-mobile-menu', { 'c-mobile-menu--active': showMenu }]"
		>
			<div class="c-mobile-menu__topbar">
				<button
					id="mobile-menu-close"
					class="c-mobile-menu__close"
					@click="closeMenu"
				>
					<v-icon name="icon-close" size="xs" />
					‍<span class="t-visually-hidden">{{
						closeMenuButtonText
					}}</span>
				</button>
			</div>
			<div class="c-mobile-menu__paneholder">
				<ul class="c-mobile-menu__list">
					<v-mobile-menu-item
						v-for="(item, index) in links"
						:key="index"
						:id="index"
						:icon="item.icon"
						:name="item.name"
						:selected="item.selected"
						:items="item.pages"
					></v-mobile-menu-item>
				</ul>
			</div>
			<div class="c-mobile-menu__logo">
				<v-logo />
			</div>
		</nav>
		<Transition name="fade">
			<div
				class="c-page-header__overlay c-page-header__overlay--mobile-menu"
				v-if="showMenu"
			></div>
		</Transition>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
import VSearch from "../../components/search/VSearch.vue";
import VLogo from "../../components/logo/VLogo.vue";
import VMobileMenuItem from "../../components/mobile-menu/VMobileMenuItem.vue";

export default {
	name: "VMobileMenu",
	components: {
		VLogo,
		VIcon,
		VSearch,
		VMobileMenuItem
	},
	props: {
		links: {
			type: Array,
			default: () => []
		},
		menuButtonText: { type: String, default: "" },
		closeMenuButtonText: { type: String, default: "" },
		className: {
			type: String
		},
		isActive: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		document.addEventListener("click", this.handleClickOutside);
		document.querySelector('#mobile-menu').addEventListener('keydown', this.handleFocusRestraint)
	},
	methods: {
		handleFocusRestraint: function(e) {
			let focusElements = getFocusableElements();
			let lastElement = focusElements[focusElements.length - 1];

			function blurEventListener() {
				focusElements[0].focus();
			}

			lastElement.addEventListener('blur', blurEventListener);

			focusElements.forEach(el => el.addEventListener('click', () => {
				lastElement.removeEventListener('blur', blurEventListener);
				focusElements = getFocusableElements();
				lastElement = focusElements[focusElements.length - 1];
			}))

			function getFocusableElements() {
				return document.querySelector("#mobile-menu").querySelectorAll(
					'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
				);
			}
		},
		handleClickOutside: function(e) {
			if (
				e.target.classList.contains(
					"c-page-header__overlay--mobile-menu"
				)
			) {
				this.closeMenu();
			}
		},
		openMenu: function(e) {
			//let pageHeader = document.getElementById('pageHeader');
			this.$emit("update:isActive", true);
			let body = document.getElementsByTagName("BODY")[0];
			if (!this.isActive) {
				//pageHeader.classList.remove("activated");
				body.classList.remove("c-search-pane--open");
				body.classList.add("c-mobile-menu--open");
			} else {
				body.classList.remove("c-mobile-menu--open");
			}
		},
		closeMenu: function(e) {
			this.$emit("update:isActive", false);
			let body = document.getElementsByTagName("BODY")[0];
			if (!this.isActive) {
				//pageHeader.classList.remove("activated");
				body.classList.remove("c-search-pane--open");
				body.classList.add("c-mobile-menu--open");
			} else {
				body.classList.remove("c-mobile-menu--open");
			}
		}
	},
	computed: {
		showMenu() {
			return this.isActive;
		}
	}
};
</script>
